import React from 'react'
import { LEGISLATION_CATEGORIES, LEGISLATION_FOLDERS, LEGISLATION_MENU } from 'constants/controllers'
import getUrl from 'libraries/front-end-core/core/url'
import NotificationImportantIcon from '@mui/icons-material/NotificationImportant'
import Xml from 'components/shared/Xml'
import Breadcrumbs from 'components/Breadcrumbs'

const LegislationBreadcrumbs = ({ act, actIdMap, isProxy = false }) => {
  const legActValue = actIdMap && actIdMap.has(act) ? actIdMap.get(act) : null
  const crumbs = [
    {
      label: 'Legislation',
      href: getUrl(LEGISLATION_FOLDERS),
      analytics: {
        category: 'Legislation',
        action: 'Back to menu'
      }
    }
  ]
  if (!isProxy && legActValue) {
    crumbs.push({
      label: legActValue.folderName,
      href: getUrl(LEGISLATION_CATEGORIES, {}, { name: legActValue.folderName }),
      analytics: {
        category: 'Legislation',
        event: 'Breadcrumb Navigation'
      }
    })
  }

  return (
    <div className='layout-width-constraint'>
      <Breadcrumbs
        crumbs={crumbs}
        current={!isProxy && legActValue ? legActValue.category : ''}
        viewAllLink={getUrl(LEGISLATION_MENU)}
        icon='legislation'
      />
      {!isProxy && legActValue && legActValue.actNote ? <ActNote {...legActValue.actNote} /> : null}
    </div>
  )
}

const ActNote = ({ description, icon }) => (
  <div className='flex items-center bg-tangerine-dream b pl6 pv3 mv3 br1'>
    {description && <Xml component='div' render={description} />}
    {icon && <NotificationImportantIcon classes={{ root: 'ml4 dark-coral' }} />}
  </div>
)

export default LegislationBreadcrumbs
